import PropTypes from 'prop-types';
import Workspace from '../../entities/workspace';
import { connectComponent } from '../../lib/connectComponent';
import { getWorkspace } from '../../selectors/workspaces';
import WorkspaceSettingsPanel from '../../new_arch/modules/workspaces/components/WorkspaceSettingsPanel/WorkspaceSettingsPanel';

export const WorkspacePanelContainer = ( { workspace } ) => (
	<div className="header-and-body">
		<WorkspaceSettingsPanel workspaceID={workspace.id} />
	</div>
);

WorkspacePanelContainer.propTypes = {
	workspace: PropTypes.instanceOf( Workspace ).isRequired,
	workspaceID: PropTypes.number.isRequired
};

export default connectComponent( ( state, props ) => ( {
	workspace: getWorkspace( state, props )
} ) )( WorkspacePanelContainer );
